import { useQuery } from '@apollo/client';
import { createContext, useContext } from 'react';
import type { KpTableWikiListQuery } from '~/apollo/generated/v4/graphql';
import { graphql } from '~/apollo/generated/v4';

const KP_TABLE_WIKI_LIST = graphql(`
  query KPTableWikiList {
    depositionalWikiList {
      results {
        id
        geologyType
        type
        value
      }
    }
    otherWikiList {
      results {
        id
        title
      }
    }
  }
`);

type DepositionalWikiList = NonNullable<
  NonNullable<KpTableWikiListQuery['depositionalWikiList']>['results']
>;
type OtherWikiList = NonNullable<
  NonNullable<KpTableWikiListQuery['otherWikiList']>['results']
>;

type Context = {
  depositionalWikiList: DepositionalWikiList;
  otherWikiList: OtherWikiList;
};

const defaultValue: Context = {
  depositionalWikiList: [],
  otherWikiList: [],
};

const KPPanelContext = createContext<Context>(defaultValue);

export function KPPanelContextProvier({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data } = useQuery(KP_TABLE_WIKI_LIST);

  return (
    <KPPanelContext.Provider
      value={{
        depositionalWikiList: data?.depositionalWikiList?.results ?? [],
        otherWikiList: data?.otherWikiList?.results ?? [],
      }}
    >
      {children}
    </KPPanelContext.Provider>
  );
}

export function useKPPanelContext() {
  return useContext(KPPanelContext);
}
